export const SessionState = {
  namespaced: true,
  state: {
    resourceViewExpanded : false,
    showResourceArrows : true,
    activeBabylonPanels : [
        {
            id : "test",
            engine : {},
            scene : {},
            canvas : {},
        }
    ]
  },

  mutations: {

    SetResourceViewExpansion(state, isExpanded)
    {
      state.resourceViewExpanded = isExpanded;
    },
    SetResourceArrowVisibility(state, showArrows)
    {
      state.showResourceArrows = showArrows;
    },
    AddNewBabylonInstance(state, newInstancePayload)
    {
        console.log("Adding new babylon instance");
        console.log(newInstancePayload);

        var newObj = {
            id: newInstancePayload.id,
            engine : newInstancePayload.engine,
            scene : newInstancePayload.scene,
            canvas : newInstancePayload.canvas
        };

        Object.freeze(newObj);
        state.activeBabylonPanels.push(newObj);
    },
    RemoveBabylonInstance(state, id)
    {
      console.log("Removing babylon instance " + id);

      for (let i = 0; i < state.activeBabylonPanels.length; i++) {
        
        if(state.activeBabylonPanels[i].id == id)
        {
          state.activeBabylonPanels.splice(i);
          break;
        }
      }
    }
  },
  actions: {

  },
  getters: {

    GetBabPnl: (state) => (id) => {
        return state.activeBabylonPanels.find(pnl => pnl.id === id);
    }
  }
}